const podwojneKola = { t: 'Podwójne tylne koła', name: 'podwojne-tylne-kola' }
export default podwojneKola